import { FLOORS } from "./constants";

const RISK_MESSAGE_KEY_MAP = {
  "Very low risk": "riskMessages.veryLow",
  "Low risk": "riskMessages.low",
  "Medium risk": "riskMessages.medium",
  "Elevated risk": "riskMessages.elevated",
  "Moderate risk": "riskMessages.moderate",
  "High risk": "riskMessages.high",
  "Very High risk": "riskMessages.veryHigh",
  "Very high risk": "riskMessages.veryHigh",
  "Πολύ χαμηλός κίνδυνος": "riskMessages.veryLow",
  "Χαμηλός κίνδυνος": "riskMessages.low",
  "Μέτριος κίνδυνος": "riskMessages.medium",
  "Αυξημένος κίνδυνος": "riskMessages.elevated",
  "Υψηλός κίνδυνος": "riskMessages.high",
  "Πολύ υψηλός κίνδυνος": "riskMessages.veryHigh",
};

const RISK_NAME_KEY_MAP = {
  Fire: "risks.fire",
  Flood: "risks.flood",
  Earthquake: "risks.earthquake",
  fire: "risks.fire",
  flood: "risks.flood",
  earthquake: "risks.earthquake",
};

const RISK_BIN_KEY_MAP = {
  Low: "riskLevels.low",
  Medium: "riskLevels.medium",
  High: "riskLevels.high",
};

export const getFloorLabelFromValue = (value, t) => {
  const floor = FLOORS.find((item) => item.value === value);
  if (!floor) return value;
  return t ? t(floor.labelKey) : floor.labelKey;
};

export const getFloorOptions = (t) =>
  FLOORS.map((option) => ({
    ...option,
    label: t(option.labelKey),
  }));

export const getRiskMessageLabel = (message, t) => {
  const key = RISK_MESSAGE_KEY_MAP[message];
  if (!key || !t) return message;
  return t(key);
};

export const getRiskNameLabel = (name, t) => {
  const key = RISK_NAME_KEY_MAP[name];
  if (!key || !t) return name;
  return t(key);
};

export const getRiskBinLabel = (bin, t) => {
  const key = RISK_BIN_KEY_MAP[bin];
  if (!key || !t) return bin;
  return t(key);
};

export const formatCurrency = (value) => {
  if (value == null || value === "") return "—";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(Number(value));
  } catch {
    return String(value);
  }
};
